import { createSelector } from "reselect"

import { getNotificationState } from "./getNotificationState"

export const getErrors = createSelector(
  getNotificationState,
  (state) => state.errors
)
